module.exports = __webpack_public_path__ + "static/media/iconFind-final.a5739d14.svg";